import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import { Accordion, Button } from "react-bootstrap";

const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active
        } pt-4 position-fixed`}
    >
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="white"
          />
        </svg>
      </Button>
      <div className={`${styles.top} top text-center px-3 py-2`}>
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion className={`${styles.linkWrpper} linkWrpper py-4`}>
        <ul className="list-unstyled ps-0 mb-0 ">
          <li className="">
            <NavLink
              to="/dashboard"
              className={`${styles.link} ${pageActive.includes("/dashboard") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M2.5 0H9.14551C10.5273 0 11.6455 1.11816 11.6455 2.5V5.93262C11.6455 7.31445 10.5273 8.43262 9.14551 8.43262H2.5C1.11816 8.43262 0 7.31445 0 5.93262V2.5C0 1.11816 1.11816 0 2.5 0Z"
                    fill="white"
                  />
                  <path
                    d="M2.5 10.2295H9.14551C10.5273 10.2295 11.6455 11.3477 11.6455 12.7295V22.5C11.6455 23.8818 10.5273 25 9.14551 25H2.5C1.11816 25 0 23.8818 0 22.5V12.7295C0 11.3477 1.11816 10.2295 2.5 10.2295Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 16.5674H22.5C23.8818 16.5674 25 17.6855 25 19.0674V22.5C25 23.8818 23.8818 25 22.5 25H15.8545C14.4727 25 13.3545 23.8818 13.3545 22.5V19.0674C13.3545 17.6855 14.4727 16.5674 15.8545 16.5674Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 0H22.5C23.8818 0 25 1.11816 25 2.5V12.2705C25 13.6523 23.8818 14.7705 22.5 14.7705H15.8545C14.4727 14.7705 13.3545 13.6523 13.3545 12.2705V2.5C13.3545 1.11816 14.4727 0 15.8545 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Dashboard
            </NavLink>
          </li>





          <li className="">
            <NavLink
              to="/guest-booking"
              className={`${styles.link} ${pageActive.includes("/guest-booking") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 25"
                  fill="none"
                >
                  <path
                    d="M0 23.6604C0 24.4001 0.59967 24.9998 1.33926 24.9998H13.8393C14.579 24.9998 15.1784 24.4001 15.1784 23.6604V22.3213H0V23.6604ZM11.6071 23.2142H12.5C12.7466 23.2142 12.9465 23.4141 12.9465 23.6604C12.9465 23.9071 12.7466 24.107 12.5 24.107H11.6071C11.3605 24.107 11.1606 23.9071 11.1606 23.6604C11.1606 23.4141 11.3605 23.2142 11.6071 23.2142ZM7.14279 23.2142H8.03558C8.28217 23.2142 8.48206 23.4141 8.48206 23.6604C8.48206 23.9071 8.28217 24.107 8.03558 24.107H7.14279C6.89621 24.107 6.69647 23.9071 6.69647 23.6604C6.69647 23.4141 6.89621 23.2142 7.14279 23.2142ZM2.67838 23.2142H3.57147C3.8179 23.2142 4.01779 23.4141 4.01779 23.6604C4.01779 23.9071 3.8179 24.107 3.57147 24.107H2.67838C2.43195 24.107 2.23206 23.9071 2.23206 23.6604C2.23206 23.4141 2.43195 23.2142 2.67838 23.2142Z"
                    fill="white"
                  />
                  <path
                    d="M11.6071 8.92874C11.6071 8.68231 11.4072 8.48242 11.1606 8.48242H10.2678C10.2678 8.729 10.0679 8.92874 9.82147 8.92874C9.57489 8.92874 9.375 8.729 9.375 8.48242H5.80338C5.80338 8.729 5.60379 8.92874 5.35706 8.92874C5.11047 8.92874 4.91058 8.729 4.91058 8.48242H4.01779C3.77121 8.48242 3.57147 8.68231 3.57147 8.92874V9.82169H11.6071V8.92874Z"
                    fill="white"
                  />
                  <path
                    d="M4.01779 16.5182H11.1606C11.4072 16.5182 11.6071 16.3183 11.6071 16.0719V10.7148H3.57147V16.0719C3.57147 16.3183 3.77121 16.5182 4.01779 16.5182ZM5.0415 13.9706C5.21576 13.7962 5.4985 13.7962 5.67276 13.9706L6.25 14.5479L9.50577 11.2919C9.68094 11.1227 9.95941 11.1253 10.1315 11.2974C10.3038 11.4695 10.3061 11.748 10.1369 11.9233L6.56555 15.4945C6.3913 15.6689 6.10855 15.6689 5.9343 15.4945L5.0415 14.6017C4.8671 14.4275 4.8671 14.1447 5.0415 13.9706Z"
                    fill="white"
                  />
                  <path
                    d="M0 21.4285H15.1784V3.125H0V21.4285ZM11.1606 20.5356H5.80338C5.55695 20.5356 5.35706 20.3357 5.35706 20.0894C5.35706 19.8427 5.55695 19.6428 5.80338 19.6428H11.1606C11.4072 19.6428 11.6071 19.8427 11.6071 20.0894C11.6071 20.3357 11.4072 20.5356 11.1606 20.5356ZM12.9465 19.6428H13.8393C14.0857 19.6428 14.2856 19.8427 14.2856 20.0894C14.2856 20.3357 14.0857 20.5356 13.8393 20.5356H12.9465C12.6999 20.5356 12.5 20.3357 12.5 20.0894C12.5 19.8427 12.6999 19.6428 12.9465 19.6428ZM4.01779 4.01779H9.375C9.62158 4.01779 9.82147 4.21768 9.82147 4.46442C9.82147 4.71069 9.62158 4.91058 9.375 4.91058H4.01779C3.77121 4.91058 3.57147 4.71069 3.57147 4.46442C3.57147 4.21768 3.77121 4.01779 4.01779 4.01779ZM4.01779 7.58942H4.91058V7.14279C4.91058 6.89621 5.11047 6.69647 5.35706 6.69647C5.60379 6.69647 5.80338 6.89621 5.80338 7.14279V7.58942H9.375V7.14279C9.375 6.89621 9.57489 6.69647 9.82147 6.69647C10.0679 6.69647 10.2678 6.89621 10.2678 7.14279V7.58942H11.1606C11.9003 7.58942 12.5 8.18878 12.5 8.92853V16.0715C12.5 16.8112 11.9003 17.4106 11.1606 17.4106H4.01779C3.27805 17.4106 2.67838 16.8112 2.67838 16.0715V8.92853C2.67838 8.18878 3.27805 7.58942 4.01779 7.58942ZM1.33926 4.01779H2.23206C2.47879 4.01779 2.67838 4.21768 2.67838 4.46442C2.67838 4.71069 2.47879 4.91058 2.23206 4.91058H1.33926C1.09268 4.91058 0.892792 4.71069 0.892792 4.46442C0.892792 4.21768 1.09268 4.01779 1.33926 4.01779Z"
                    fill="white"
                  />
                  <path
                    d="M13.8393 0H8.03558V0.446472C8.03558 0.692902 7.83569 0.892792 7.58926 0.892792C7.34268 0.892792 7.14279 0.692902 7.14279 0.446472V0H1.33926C0.59967 0 0 0.59967 0 1.33942V2.23221H15.1784V1.33942C15.1784 0.59967 14.579 0 13.8393 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Booking
            </NavLink>
          </li>


          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="3"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M23.7492 18.7422H20.2245L21.0619 13.7426H22.4993C22.7613 13.7433 23.017 13.6616 23.23 13.509C23.4431 13.3565 23.6029 13.1409 23.6867 12.8926L24.9366 9.1429C25.0231 8.88169 25.021 8.59923 24.9306 8.33934C24.8402 8.07945 24.6666 7.85665 24.4367 7.7055L13.1875 0.20603C12.9834 0.0716298 12.7444 0 12.5 0C12.2556 0 12.0166 0.0716298 11.8125 0.20603L0.563337 7.7055C0.333403 7.85665 0.159771 8.07945 0.0693742 8.33934C-0.0210228 8.59923 -0.0231328 8.88169 0.0633716 9.1429L1.31328 12.8926C1.39713 13.1409 1.55689 13.3565 1.76997 13.509C1.98304 13.6616 2.23866 13.7433 2.5007 13.7426H3.9381L4.77554 18.7422H1.25079C0.919291 18.7422 0.601371 18.8739 0.366967 19.1083C0.132563 19.3427 0.000876005 19.6606 0.000876005 19.9921V23.7419C0.000876005 24.0734 0.132563 24.3913 0.366967 24.6257C0.601371 24.8601 0.919291 24.9918 1.25079 24.9918H23.7492C24.0807 24.9918 24.3986 24.8601 24.633 24.6257C24.8674 24.3913 24.9991 24.0734 24.9991 23.7419V19.9921C24.9991 19.6606 24.8674 19.3427 24.633 19.1083C24.3986 18.8739 24.0807 18.7422 23.7492 18.7422ZM17.6871 18.7422H13.7499V13.7426H18.5246L17.6871 18.7422ZM12.5 4.99319C12.9944 4.99319 13.4777 5.13981 13.8888 5.41449C14.2999 5.68918 14.6203 6.07959 14.8095 6.53638C14.9987 6.99316 15.0482 7.49579 14.9518 7.98071C14.8553 8.46563 14.6172 8.91105 14.2676 9.26066C13.918 9.61027 13.4726 9.84835 12.9877 9.94481C12.5028 10.0413 12.0001 9.99176 11.5434 9.80256C11.0866 9.61335 10.6962 9.29294 10.4215 8.88185C10.1468 8.47075 10.0002 7.98744 10.0002 7.49302C10.0002 6.83002 10.2635 6.19418 10.7324 5.72538C11.2012 5.25657 11.837 4.99319 12.5 4.99319ZM6.47542 13.7426H11.2501V18.7422H7.31286L6.47542 13.7426Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Reports
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">

                  <li className="">
                    <NavLink
                      to="/reports/booking-report"
                      className={`${styles.subLinks} ${pageActive.includes("/booking-report") && styles.active
                        } text-white`}
                    >
                      Booking Report
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          {/* <li className="">
            <NavLink
              to="/transaction-history"
              className={`${styles.link} ${pageActive.includes("/transaction-history") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <g clip-path="url(#clip0_66_2653)">
                    <path
                      d="M6.5918 18.3105H11.8652V19.9707H6.5918V18.3105Z"
                      fill="white"
                    />
                    <path
                      d="M14.0137 0.431641V4.73633H18.2744L14.0137 0.431641Z"
                      fill="white"
                    />
                    <path
                      d="M6.5918 15.1855H11.8652V16.8457H6.5918V15.1855Z"
                      fill="white"
                    />
                    <path
                      d="M3.4668 15.1855H5.12695V16.8457H3.4668V15.1855Z"
                      fill="white"
                    />
                    <path
                      d="M11.8652 12.4023C11.8652 10.3828 13.5078 8.74023 15.5273 8.74023H18.7012V6.20117H13.2812C12.877 6.20117 12.5488 5.87305 12.5488 5.46875V0H2.19727C0.98584 0 0 0.98584 0 2.19727V21.1914C0 22.4028 0.98584 23.3887 2.19727 23.3887H11.9126C11.8813 23.1978 11.8652 23.002 11.8652 22.8027V21.4355H2.73438C2.33008 21.4355 2.00195 21.1074 2.00195 20.7031V14.4531C2.00195 14.0488 2.33008 13.7207 2.73438 13.7207H11.8652V12.4023ZM6.43213 8.51709C6.29883 9.31055 5.74854 9.94141 5.02686 10.2012C5.00391 10.5845 4.68604 10.8887 4.29688 10.8887C3.93652 10.8887 3.63721 10.6279 3.57666 10.2852C3.23438 10.2266 2.92334 10.1006 2.5293 9.84277C2.19092 9.62109 2.0957 9.16748 2.31738 8.82861C2.53857 8.49023 2.99268 8.39551 3.33105 8.6167C3.68799 8.85059 3.80371 8.86865 4.29199 8.86523C4.76318 8.8623 4.95068 8.49219 4.9873 8.27441C5.02051 8.07861 4.9834 7.81836 4.62061 7.68994C4.01221 7.4751 3.38867 7.22852 2.94678 6.88184C2.47705 6.51318 2.26074 5.88086 2.3833 5.23193C2.50928 4.56494 2.96094 4.02783 3.57178 3.80908C3.61914 3.45068 3.92529 3.17383 4.29688 3.17383C4.69434 3.17383 5.01709 3.49072 5.02832 3.88525C5.1875 3.94385 5.33984 4.01318 5.48047 4.08643C5.90234 4.30615 6.00049 4.8667 5.67773 5.2168C5.4502 5.46387 5.08154 5.52344 4.79053 5.35645C4.56201 5.2251 4.29199 5.11816 4.08154 5.18164C3.88672 5.24023 3.83398 5.44287 3.82275 5.50342C3.79883 5.62988 3.83301 5.71484 3.85107 5.729C4.12744 5.9458 4.6416 6.14404 5.1084 6.30859C6.06543 6.64697 6.59717 7.53467 6.43213 8.51709Z"
                      fill="white"
                    />
                    <path
                      d="M3.4668 18.3105H5.12695V19.9707H3.4668V18.3105Z"
                      fill="white"
                    />
                    <path
                      d="M16.748 13.623H21.5332V15.2832H16.748V13.623Z"
                      fill="white"
                    />
                    <path
                      d="M22.8027 10.2051H15.5273C14.3159 10.2051 13.3301 11.1909 13.3301 12.4023V22.8027C13.3301 24.0142 14.3159 25 15.5273 25H22.8027C24.0142 25 25 24.0142 25 22.8027V12.4023C25 11.1909 24.0142 10.2051 22.8027 10.2051ZM15.2832 12.8906C15.2832 12.4861 15.6111 12.1582 16.0156 12.1582H22.2656C22.6701 12.1582 22.998 12.4861 22.998 12.8906V16.0156C22.998 16.4201 22.6701 16.748 22.2656 16.748H16.0156C15.6111 16.748 15.2832 16.4201 15.2832 16.0156V12.8906ZM16.0166 22.998C15.6121 22.998 15.2839 22.6701 15.2839 22.2656C15.2839 21.8611 15.6116 21.5332 16.0161 21.5332H16.0166C16.4211 21.5332 16.749 21.8611 16.749 22.2656C16.749 22.6701 16.4211 22.998 16.0166 22.998ZM16.0166 19.873C15.6121 19.873 15.2839 19.5451 15.2839 19.1406C15.2839 18.7361 15.6116 18.4082 16.0161 18.4082H16.0166C16.4211 18.4082 16.749 18.7361 16.749 19.1406C16.749 19.5451 16.4211 19.873 16.0166 19.873ZM19.1416 22.998C18.7371 22.998 18.4089 22.6701 18.4089 22.2656C18.4089 21.8611 18.7366 21.5332 19.1411 21.5332H19.1416C19.5461 21.5332 19.874 21.8611 19.874 22.2656C19.874 22.6701 19.5461 22.998 19.1416 22.998ZM19.1416 19.873C18.7371 19.873 18.4089 19.5451 18.4089 19.1406C18.4089 18.7361 18.7366 18.4082 19.1411 18.4082H19.1416C19.5461 18.4082 19.874 18.7361 19.874 19.1406C19.874 19.5451 19.5461 19.873 19.1416 19.873ZM22.2666 22.998C21.8621 22.998 21.5339 22.6701 21.5339 22.2656C21.5339 21.8611 21.8616 21.5332 22.2661 21.5332H22.2666C22.6711 21.5332 22.999 21.8611 22.999 22.2656C22.999 22.6701 22.6711 22.998 22.2666 22.998ZM22.2666 19.873C21.8621 19.873 21.5339 19.5451 21.5339 19.1406C21.5339 18.7361 21.8616 18.4082 22.2661 18.4082H22.2666C22.6711 18.4082 22.999 18.7361 22.999 19.1406C22.999 19.5451 22.6711 19.873 22.2666 19.873Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_66_2653">
                      <rect width="25" height="25" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Transaction History
            </NavLink>
          </li> */}


          {/* <li className="">
            <NavLink
              to="/wallet"
              className={`${styles.link} ${pageActive.includes("/wallet") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-wallet2" viewBox="0 0 16 16">
                  <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                </svg>
              </span>
              Wallet
            </NavLink>
          </li> */}

          {/* <li className="">
            <NavLink
              to="/chat"
              className={`${styles.link} ${pageActive.includes("/chat") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none"><path d="M612 4197 l-22 -23 0 -1410 0 -1411 23 -21 c23 -22 28 -22 370 -22 191 0 347 -2 347 -5 0 -2 -25 -122 -55 -267 -30 -144 -55 -277 -55 -295 0 -38 30 -63 75 -63 25 0 81 47 370 315 l340 314 1241 1 1241 0 21 23 22 23 0 1410 0 1411 -23 21 -23 22 -1925 0 -1926 0 -21 -23z m3768 -1432 l0 -1305 -1211 0 c-778 0 -1217 -4 -1229 -10 -10 -5 -130 -113 -266 -240 -136 -126 -249 -228 -250 -227 -2 1 17 92 42 202 24 109 42 207 38 217 -3 9 -17 27 -31 38 -25 19 -39 20 -379 20 l-354 0 0 1305 0 1305 1820 0 1820 0 0 -1305z"></path></g></svg>
              </span>
              Chat
            </NavLink>
          </li> */}

        </ul>
      </Accordion>
    </div>
  );
};

export default Sidebar;
